module.exports = __webpack_public_path__ + "img/_MG_8724.63a9b7af.jpg";